export default {
      id: "flex-alignItems-flex-start-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-alignItems-flex-start-usage",
      toString: function () {
        return this.url;
      }
    }